export default "__VITE_ASSET__Te4w7Ofv__"